(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lp102-ruby-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lp102-ruby-gallery')) {
  customElements.define('lp102-ruby-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const slides = [...this.querySelectorAll('.lp-ruby-gallery__slide')];
      const thumbs = [...this.querySelectorAll('[data-index]')];
      let index = 0;
      const show = next => {
        index = (next + slides.length) % slides.length;
        for (const [i, slide] of slides.entries()) slide.hidden = i !== index;
        for (const [i, thumb] of thumbs.entries()) thumb.setAttribute('aria-pressed', String(i === index));
        this.querySelector('[data-gallery-status]').textContent = `Image ${index + 1} of ${slides.length}`;
      };
      this.querySelector('.lp-ruby-gallery__prev').addEventListener('click', () => show(index - 1));
      this.querySelector('.lp-ruby-gallery__next').addEventListener('click', () => show(index + 1));
      for (const thumb of thumbs) thumb.addEventListener('click', () => show(Number(thumb.dataset.index)));
      this.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); show(index + (event.key === 'ArrowRight' ? 1 : -1)); }
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wtc-countdown"] && !Shopify.designMode) return;
  try {
    const WCD_UNITS = [
    ['d', 'Days'],
    ['h', 'Hrs'],
    ['m', 'Min'],
    ['s', 'Sec'],
  ];

  /**
   * One ticker drives every clock on the page. Four countdowns used to mean
   * four independent 1s intervals, each still firing while the tab sat in the
   * background; now they share a single timer that stops whenever the page is
   * hidden and whenever the last clock leaves the DOM.
   */
  const WCD_LIVE = new Set();
  let WCD_TIMER = null;

  function wcdPump() {
    for (const el of WCD_LIVE) el.tick();
  }
  function wcdSync() {
    const shouldRun = !document.hidden && WCD_LIVE.size > 0;
    if (shouldRun && WCD_TIMER === null) {
      WCD_TIMER = setInterval(wcdPump, 1000);
      wcdPump();
    } else if (!shouldRun && WCD_TIMER !== null) {
      clearInterval(WCD_TIMER);
      WCD_TIMER = null;
    }
  }
  // A hidden tab paints nothing, so there is nothing worth counting down to.
  // Deliberately NOT gated on viewport intersection as well: the saving is
  // negligible next to this, and a clock that is wrongly judged off-screen
  // would sit frozen on a live sale page.
  document.addEventListener('visibilitychange', wcdSync);

  /**
   * Rolling odometer countdown shared by every WTC sale section.
   * Digits are aria-hidden; the deadline is announced once via a static
   * sentence, because a per-second live region floods assistive tech.
   */
  class WtcCountdown extends HTMLElement {
    #frame = false;

    connectedCallback() {
      this.digits = this.querySelector('[data-wcd-digits]');
      const raw = this.dataset.deadline;
      if (!this.digits || !raw) return;

      this.deadline = new Date(raw);
      if (Number.isNaN(this.deadline.getTime())) return;

      // cycle mode: one shared clock that rolls over instead of expiring
      const cycleS = Number(this.dataset.cycleS);
      if (cycleS > 0) {
        this.cycleMs = cycleS * 1000;
        this.anchorMs = Number(this.dataset.anchorS) * 1000;
      }

      this.#build();
      this.#render();
      WCD_LIVE.add(this);
      wcdSync();
    }

    disconnectedCallback() {
      WCD_LIVE.delete(this);
      wcdSync();
    }

    /** Called by the shared ticker. */
    tick() {
      this.#schedule();
    }

    #build() {
      const frag = document.createDocumentFragment();
      for (const [, label] of WCD_UNITS) {
        const unit = document.createElement('span');
        unit.className = 'wcd__u';

        const cells = document.createElement('span');
        cells.className = 'wcd__cells';

        for (let i = 0; i < 2; i++) {
          const cell = document.createElement('span');
          cell.className = 'wcd__cell';
          const strip = document.createElement('span');
          strip.className = 'wcd__strip';
          for (let n = 0; n <= 9; n++) {
            const digit = document.createElement('span');
            digit.textContent = String(n);
            strip.appendChild(digit);
          }
          cell.appendChild(strip);
          cells.appendChild(cell);
        }

        const lab = document.createElement('span');
        lab.className = 'wcd__lab';
        lab.textContent = label;

        unit.append(cells, lab);
        frag.appendChild(unit);
      }
      this.digits.appendChild(frag);
      this.units = this.digits.querySelectorAll('.wcd__u');
    }

    #schedule() {
      if (this.#frame) return;
      this.#frame = true;
      requestAnimationFrame(() => {
        this.#frame = false;
        this.#render();
      });
    }

    #deadlineMs() {
      if (!this.cycleMs) return this.deadline.getTime();
      const now = Date.now();
      if (now <= this.anchorMs) return this.anchorMs;
      const done = Math.floor((now - this.anchorMs) / this.cycleMs);
      return this.anchorMs + (done + 1) * this.cycleMs;
    }

    #render() {
      const ms = Math.max(0, this.#deadlineMs() - Date.now());
      const total = Math.floor(ms / 1000);
      const parts = {
        d: Math.floor(total / 86400),
        h: Math.floor((total % 86400) / 3600),
        m: Math.floor((total % 3600) / 60),
        s: total % 60,
      };

      WCD_UNITS.forEach(([key], i) => {
        const value = String(parts[key]).padStart(2, '0');
        const strips = this.units[i].querySelectorAll('.wcd__strip');
        strips[0].style.setProperty('--n', value[0]);
        strips[1].style.setProperty('--n', value[1]);
      });

      // Drop the days column once it reads 00 — on a phone it is what pushes
      // the seconds off the edge, and it says nothing.
      this.units[0].hidden = parts.d === 0;

      if (ms === 0) {
        // Cycle mode never expires: the next tick lands in the fresh cycle.
        if (this.cycleMs) return;
        // Mark the owning section so CSS can hide it or swap the copy.
        this.closest('[data-wtc-sale]')?.setAttribute('data-expired', 'true');
        this.dispatchEvent(new CustomEvent('wtc:countdown-ended', { bubbles: true }));
        // Retire from the shared ticker; a finished clock has nothing left to do.
        WCD_LIVE.delete(this);
        wcdSync();
      }
    }
  }

  if (!customElements.get('wtc-countdown')) {
    customElements.define('wtc-countdown', WtcCountdown);
  }
  } catch(e) { console.error(e); }
})();

})();
